/**
 * Created by razial on 21.05.2026.
 */

if (cleverapps.styles.SingleProductOfferWindow && cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.KINGSCUP]) {
    cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.KINGSCUP], {
        rewards: {
            worker: {
                rotation: 0,
                x: { align: "center", dx: 500 },
                y: { align: "center", dy: -200 }
            },
            energy: {
                rotation: 0,
                x: { align: "center", dx: -535 },
                y: { align: "center", dy: -200 }
            }
        }
    });
}
